const STREAM_TAG = "#EXT-X-STREAM-INF:";
const MIN_SCORE_HLS_VERSION = 8;
const HEVC_SCORE_FAMILY_OFFSET = 10_000;
function quotedAttribute(line, name) {
    return new RegExp(`(?:^|,)${name}="([^"]*)"`).exec(line)?.[1] ?? null;
}
function resolutionHeight(line) {
    const raw = new RegExp("(?:^|,)RESOLUTION=[0-9]+x([0-9]+)(?=,|$)").exec(line)?.[1];
    const height = raw ? Number(raw) : Number.NaN;
    return Number.isFinite(height) ? height : null;
}
function replaceScore(line, score) {
    const value = `${score.toFixed(1)}`;
    return /(?:^|,)SCORE=[0-9]+(?:\.[0-9]+)?(?=,|$)/.test(line)
        ? line.replace(/(^|,)SCORE=[0-9]+(?:\.[0-9]+)?(?=,|$)/, `$1SCORE=${value}`)
        : `${line},SCORE=${value}`;
}
/**
 * Apple HLS applies SCORE after compatibility filtering. Rank every HEVC
 * variant above every H.264 variant so HEVC acts as the preferred mutually
 * exclusive family, then rank resolution within each family. Giving every
 * HEVC rung the same score leaves Safari free to cap an inline player at 1080p
 * even when the 2160p rendition is playable.
 */
export function scorePreferredHevcCodecFamily(manifest) {
    const lines = manifest.split("\n");
    const streamLines = lines.filter((line) => line.startsWith(STREAM_TAG));
    if (streamLines.length === 0)
        return manifest;
    const variants = streamLines.map((line) => {
        const codecs = quotedAttribute(line, "CODECS")?.toLowerCase() ?? "";
        const height = resolutionHeight(line);
        const family = codecs.includes("hvc1") || codecs.includes("hev1")
            ? "hevc"
            : codecs.includes("avc1") || codecs.includes("avc3")
                ? "h264"
                : null;
        return { family, height };
    });
    if (variants.some((variant) => !variant.family || variant.height === null) ||
        !variants.some((variant) => variant.family === "hevc") ||
        !variants.some((variant) => variant.family === "h264")) {
        return manifest;
    }
    let variantIndex = 0;
    return lines
        .map((line) => {
        if (line.startsWith("#EXT-X-VERSION:")) {
            const version = Number(line.slice("#EXT-X-VERSION:".length));
            return `#EXT-X-VERSION:${Math.max(Number.isFinite(version) ? version : 0, MIN_SCORE_HLS_VERSION)}`;
        }
        if (!line.startsWith(STREAM_TAG))
            return line;
        const variant = variants[variantIndex++];
        const resolutionScore = variant.height;
        return replaceScore(line, resolutionScore +
            (variant.family === "hevc" ? HEVC_SCORE_FAMILY_OFFSET : 0));
    })
        .join("\n");
}
